import { render } from "./CrdmMonth.vue?vue&type=template&id=2ee165d6&scoped=true"
import script from "./CrdmMonth.vue?vue&type=script&lang=js"
export * from "./CrdmMonth.vue?vue&type=script&lang=js"

import "./CrdmMonth.vue?vue&type=style&index=0&id=2ee165d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ee165d6"

export default script